<template>
  <div id="app" :class="languageClass" style="min-width: 1000px;overflow: hidden" @drop="drop" @dragover="drop">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      timer: null
    }
  },
  computed: {
    languageClass() {
      return this.$store.getters.language === 'zh' ? 'zh' : 'en'
    }
  },
  methods: {
    drop(event) {
      event.preventDefault(); event.stopPropagation()
    }
  }
}
</script>
